import { toBaseUnitCost } from './stockQuantityUtils';

export const lineProductCost = (quantity, unitCost) => {
  if (unitCost == null || unitCost === '') {
    return null;
  }

  const cost = Number(unitCost);
  const amount = Number(quantity);
  if (!Number.isFinite(cost) || !Number.isFinite(amount)) {
    return null;
  }

  return Math.round(amount * cost * 100) / 100;
};

export const estimateRecipeCost = (lines = [], products = []) => {
  let knownTotal = 0;
  let missingCost = false;

  const detailed = (lines || []).map((line) => {
    const product = (products || []).find((item) => String(item.id) === String(line.productId));
    const packageCost = line.unitCost ?? product?.lastUnitCost ?? null;
    const contentQuantity = line.contentQuantity ?? product?.contentQuantity ?? 1;
    const unitCost = toBaseUnitCost(packageCost, contentQuantity);
    const lineCost = lineProductCost(line.quantity, unitCost);
    if (lineCost == null) {
      missingCost = true;
    } else {
      knownTotal += lineCost;
    }

    return {
      ...line,
      unitCost: unitCost == null ? null : Number(unitCost),
      lineCost,
    };
  });

  return {
    lines: detailed,
    totalCost: missingCost ? null : Math.round(knownTotal * 100) / 100,
    knownTotal: Math.round(knownTotal * 100) / 100,
    missingCost,
  };
};

export const estimateMargin = (price, productCost) => {
  if (productCost == null || !Number.isFinite(Number(price))) {
    return null;
  }

  return Math.round((Number(price) - Number(productCost)) * 100) / 100;
};
